// extracted by mini-css-extract-plugin
export default {"demo":"TagsInput_demo__HUUOf","suggesstion_box":"TagsInput_suggesstion_box__EaX1S"};